import { Node } from '@xyflow/react';
import { useImportConfiguration } from 'src/context/import-configuration';
import {
  getEdgeIds,
  getSwitchNodeIds,
  getDeviceLikeNodeIds,
} from 'src/context/import-configuration/import-review-helpers';
import { NodeModel } from 'src/modules/network-configuration/models/node-model';

export default function ImportStepSummary() {
  const { dialogState } = useImportConfiguration();

  if (!dialogState?.projectJsonData) return null;

  const p = dialogState.projectJsonData;
  const nodes = p.nodes as Node<NodeModel>[];
  const switchN = getSwitchNodeIds(nodes).length;
  const deviceN = getDeviceLikeNodeIds(nodes).length;
  const edgeN = getEdgeIds(p.edges).length;

  return (
    <div className="w-full space-y-3 text-sm text-gray-700">
      <p className="font-medium text-gray-900">Ready to apply import</p>
      <ul className="list-inside list-disc space-y-1 rounded border border-gray-200 bg-white p-4">
        <li>VLANs: {p.vlans.length}</li>
        <li>Switches: {switchN}</li>
        <li>Devices: {deviceN}</li>
        <li>Connections: {edgeN}</li>
        <li>Custom VLAN: {p.useCustomVlan ? 'Yes' : 'No'}</li>
        <li>Files decoded: {dialogState.decodedFiles.length}</li>
        {dialogState.failedFiles > 0 && (
          <li className="text-amber-700">
            Failed files (skipped): {dialogState.failedFiles}
          </li>
        )}
      </ul>
      {!!dialogState.warnings.length && (
        <div className="max-h-32 overflow-y-auto rounded bg-amber-50 p-3 text-amber-800">
          {dialogState.warnings.map((w) => (
            <p key={w}>{w}</p>
          ))}
        </div>
      )}
      <p className="text-gray-500">
        Click <strong>Import</strong> to load this configuration into the board.
      </p>
    </div>
  );
}
